const DomainStatusColor = {
  OK: '#7ECF42',
  NotOK: '#E74C3C'
};

export { DomainStatusColor };
